import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

/**
 * Property decorator which enhances the ngOnDestroy method to automatically
 * unsubscribe any subscriptions which are added to the decorated property
 * @param target - Prototype of the class which is using the decorator
 * @param propertyName  - Name of the property. The property itself can be an
 * array of Subscriptions, or a single subscription, this decorator will handle either
 * scenario,
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function ComponentSubscription(target: OnDestroy, propertyName: string) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const orig = target['ngOnDestroy'] || function () {};

    target['ngOnDestroy'] = function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let subscriptions: Subscription[] | Subscription = (this as any)[propertyName];
        if (subscriptions) {
            if (Object.prototype.toString.call(subscriptions) !== '[object Array]') {
                // Subscriptions are not in array format, so create one
                subscriptions = [subscriptions as Subscription];
            }
            (subscriptions as Subscription[]).forEach((sub: Subscription) => !!sub && !!sub.unsubscribe && !sub.closed && sub.unsubscribe());
            (subscriptions as Subscription[]).length = 0;
        }
        orig.call(this);
    };
}
